export default {
  ASNlist: {
    asnNo: 'ASN单号',
    status: '状态',
    deliveryDate: '发货日期',
    purchaseUnitName: '采购中心',
    supplierName: '供应商',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    deliveryQty: '发货量',
    receiveQty: '已收货量',
    unreceivedQty: '未收量',
    vehicle: '车位已预约',
    noBooked: '无需预约',
    ahead: '提前送货',
    delay: '延迟送货',
    normal: '正常送货',
    receive: '收货',
    cancel: '取消收货',
    settle: '结案',
    examine: '审批',
    checkStatus0: '待审批',
    checkStatus1: '已拒绝',
    checkStatus2: '已发货',
    checkStatus3: '部分收货',
    checkStatus4: '已收货',
    checkStatusX: '已作废',
    cancellationTitle: '是否作废此asn单据?',
    showRejectReason: '查看拒绝原因',
    print: '标签列印',
    unitNo: '单位'
  },
  Search: {
    purchaseUnitName: '采购中心',
    deliveryDateStart: '发货日期-起',
    deliveryDateEnd: '发货日期-止',
    asnNo: '发货单号',
    goodsName: '品名',
    spec: '规格',
    goodsNo: '料号',
    purchaseNo: '订单单号',
    supplierNo: '供应商编号',
    searchPlaceholder: '品名/ASN单号/供应商名称',
    dateRange: '发货日期范围'
  },
  Particulars: {
    supplierName: '供应商名称',
    confirmReject: '是否确认拒绝?',
    confirmResolve: '是否确认同意',
    closedStatusName: '结案状态',
    asnNo: 'ASN单号',
    supplierInfo: '供应商资料',
    billInfo: '发货资料',
    otherInfo: '其他信息',
    procurementUnit: '采购中心',
    shippingAddress: '收货地址',
    consignee: '收货人',
    information: '联系方式',
    expectedArrivalDate: '预计到货日期',
    receivingTime: '收货时段',
    orderType: '订单性质',
    orderType1: '一般订单',
    orderType2: '委外订单',
    orderType3: 'VMI订单',
    shippingWarehouse: '送达仓库',
    deliveryAddress: '发货地址',
    sender: '发货人',
    delWarehouse: '发货仓库',
    senderPhone: '发货人联系方式',
    remarks: '备注',
    accessory: '附件',
    accessorys: '附件详情',
    invoice: '发票',
    totalInvoices: ' 张发票',
    look: ' 查看发票',
    titleInvoice: '发票详情',
    invoiceType: '发票类型',
    invoiceType1: '普通发票',
    invoiceType2: '增值税普通发票',
    invoiceType3: '增值税专用',
    invoiceClassify: '发票种类',
    invoiceClassify1: '纸质发票',
    invoiceClassify2: '电子发票',
    invoiceNo: '发票号码',
    invoiceDate: '发票日期',
    invoiceAmount: '发票金额',
    taxAmount: '税额',
    taxRate: '税率',
    isGoodsInvoice: '随货发票',
    isGoodsInvoice1: '是',
    isGoodsInvoice2: '否',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    purchaseNo: '订单单号',
    purchaseSeq: '项次/项序',
    purchasePhaseSeq: '项序',
    purchaseSeqs: '项次/项序/分批次',
    purchaseBatchSeq: '分批序',
    deliveryQty: '发货量',
    giftQty: '赠送量',
    valuationQty: '计价数量',
    supRemarks: '供应商备注',
    totalAaccessory: '个附件',
    close: '关闭',
    headInfo: '基础信息',
    deliveryDetail: '发货单明细',
    forwarding: '发运信息',
    wayCarriage: '运送方式',
    wayCarriage1: '快递',
    wayCarriage2: '物流',
    wayCarriage3: '自运',
    trackingNo: '单号信息',
    carType: '车辆类型',
    carNo: '车辆号码',
    carInfo: '车辆说明',
    driver: '送货人',
    driverPhone: '送货人号码',
    placeholder: '请选择配送方式',
    cancel: '返回',
    establish: '确认收货',
    closedTitle: '结案发货单身',
    consigneeParticulars: '收货单详情',
    warehouseKeeper: '仓管员',
    practicalData: '实际到货日期',
    receiveQty: '已收货量',
    receiptQty: '收货量',
    warehouse: '仓库',
    sumDeliveryQty: '发货总量',
    sumReceiveQty: '收货总量',
    control: '控制按钮',
    asnNoAudit: 'ASN审批',
    deny: '拒绝',
    consent: '同意',
    callOff: '取消收货',
    receiptNo: '收货单号',
    outReceiptNo: '外部收货单号',
    receiptDate: '收货日期',
    stencil: '选择模板',
    Printthetemplate: '打印模板  ',
    hint: '收货单号/外部收货单号',
    hint1: '取消收货成功!',
    hint2: '结案成功!',
    hint3: '收货成功!',
    hint4: '只能勾选一笔数据!',
    hint5: '收货数量需大于0!',
    receiptQtyError: '收货量有误',
    barcodePrint: '标签列印',
    unitNo: '单位',
    refundQty: '验退量'
  }
}
